import { atom } from 'jotai';
const fallbackConfig = {
    languages: [
        { value: 'zh-CN', label: '中文' },
        { value: 'en-US', label: 'English' },
    ],
    styles: [
        { value: 'plain', label: '简洁' },
        { value: 'immersive', label: '沉浸' },
        { value: 'humor', label: '幽默' },
        { value: 'classical', label: '古风' },
        { value: 'scifi', label: '科幻' },
    ],
    persons: [
        { value: 'first', label: '第一人称' },
        { value: 'second', label: '第二人称' },
        { value: 'third', label: '第三人称' },
    ],
    defaults: { language: 'zh-CN', writingStyle: 'immersive', person: 'second', fontSize: 16 },
};
export const readingConfigAtom = atom(fallbackConfig);
